<template>
  <div class="servicetoDetails">
    <el-form ref="form">
      <el-row class="tit">
        <el-col :span="24">服务单信息</el-col>
      </el-row>
      <el-row>
        <el-col :span="1">
          <div class="seize"></div>
        </el-col>
        <el-col :span="7">
          <label>
            <span>服务单编号</span>
          </label>{{form.orderServeId}}
        </el-col>
        <el-col :span="7">
          <label>
            <span>是否预约</span>
          </label>{{form.isAppoint == 1?'是':'否'}}
        </el-col>
        <el-col :span="7">
          <label>
            <span>会员</span>
          </label>{{form.memberName | filterRow}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="1">
          <div class="seize"></div>
        </el-col>
        <el-col :span="7">
          <label>
            <span>手机号</span>
          </label>{{form.memberPhone}}
        </el-col>
        <el-col :span="7">
          <label>
            <span>项目</span>
          </label><div class="listLineH"><span v-for="(i,index) in form.serviceList" :key="index">{{i.serviceName}}{{form.serviceList.length-1 == index ? '' : '，'}}</span></div>
        </el-col>
        <el-col :span="7">
          <label>
            <span>员工</span>
          </label>{{form.technicianName}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="1">
          <div class="seize"></div>
        </el-col>
        <el-col :span="7">
          <label>
            <span>服务开始时间</span>
          </label>{{form.startTime | filterRow}}
        </el-col>
        <el-col :span="7">
          <label>
            <span>服务结束时间</span>
          </label>{{form.endTime | filterRow}}
        </el-col>
        <el-col :span="7">
          <label>
            <span>预约时间</span>
          </label>{{form.scheduleStartTime | filterRow}}
        </el-col>        
      </el-row>
      <el-row>
        <el-col :span="1">
          <div class="seize"></div>
        </el-col>
        <el-col :span="7">
          <label>
            <span>创建时间</span>
          </label>{{form.createTime | formatDateLine}}
        </el-col>
        <el-col :span="7">
          <label>
            <span>状态</span>
          </label>{{form.status | filterAtatus}}
        </el-col>
        <el-col :span="7">
          <label>
            <span>服务方式</span>
          </label>{{form.isHome == 1?'上门-'+form.serviceAddr:'到店'}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span='1'><div class="seize"></div></el-col>
        <el-col :span="7">
          <label>
            <span>留言</span>
          </label>
          <div class="listLineH">{{form.message | filterRow}}</div>
        </el-col>
        <el-col :span='7' v-if="form.status == 4">
          <!-- 已取消 -->
          <label><span>调理小结</span></label><div class="listLineH">{{form.remark | filterRow}}</div>
        </el-col>
        <el-col :span='7' v-if="form.status == 5">
          <!-- 已取消 -->
          <label><span>取消原因</span></label><div class="listLineH">{{form.cancelReason | filterRow}}</div>
        </el-col>
      </el-row>
      <el-row class="tit">
        <el-col :span="24">处理记录</el-col>
      </el-row>
      <el-row>
          <el-col :span="1">
          <div class="seize"></div>
        </el-col>
        <el-col :span="20">
            <div class="logDetails" v-if="logRecordList.length > 0">
                <div class="leftpoint" v-for="(i,index) in logRecordList" :key="index">{{i.time+'&nbsp;'+i.postType+'&nbsp;'+i.person+'&nbsp;'+i.status}}</div>
            </div>
            <span v-else>无</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="1">
          <div class="seize"></div>
        </el-col>
        <el-col :span="23">
          <div class="btnOptionsLast">
            <el-button class="darkBtn" @click="closeTab">关闭</el-button>
            <el-button class="redBtn" v-if="limitCancel === 'cancel' && form.status == 3" @click="cancelAbnormal(form)">异常取消</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog title="异常取消服务单" class="dialogVisible" :visible.sync="dialogTableVisible" :center="true" width="580px">
        <confirmTel :dialogType="dialogType" :dialogTableVisible="dialogTableVisible" @closeDialog="closeDialog" :curRowchoose="curChooseRow"/>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import {formatDate} from '@/components/common/js/date.js';  
import confirmTel from '../operatingFloor/confirmTel';
import { getOrderServeDetails, allStaff } from "@/api";
import infolist from '@/assets/js/info'
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
  components: {
    confirmTel
  },
  data() {
    return {
      form: {
        serviceRevise: {},
        payDetails:{},        
      },
      postPerson:'',//所有员工
      dialogTableVisible:false,
      dialogType:'',// 几个弹窗的识别
      curChooseRow:'',
      infolist:infolist,
    };
  },
  created() {
    this.detailInfo();
  },
  computed: {
      limitCancel(){
          for(let i of this.$store.state.resourceList){
            if(i.url === '/serviceAbnormal'){
                return 'cancel';
                break
            }
          }
      },
      logRecordList(){
        // 分配预约单allocationTime allocationOperatorName开始服务startTime technicianName 完成服务endTime technicianName 取消cancelTime cancelOperatorName 再分配transferList.createTime transferList.operatorName
        let data = [];
        if(this.form.allocationTime){
          data.push({
            time:this.form.allocationTime,
            person:this.form.allocationOperatorName,
            postType:this.searchPost(this.form.allocationOperatorId),
            status:'分配预约单'
          })
        }if(this.form.startTime){
          data.push({
            time:this.form.startTime,
            person:this.form.technicianName,
            postType:'员工',
            status:'开始服务'
          })
        }if(this.form.endTime){
          data.push({
            time:this.form.endTime,
            person:this.form.technicianName,
            postType:'员工',
            status:'完成服务'
          })
        }if(this.form.cancelTime){
          data.push({
            time:this.form.cancelTime,
            person:this.form.cancelOperatorName,
            postType:this.searchPost(this.form.cancelOperatorId),
            status:'取消'
          })
        }
        if(this.form.transferList && this.form.transferList.length > 0){
          for(let i of this.form.transferList){
            data.push({
              time:i.createTime,
              person:i.operatorName,
              postType:this.searchPost(i.operatorId),
              status:'再分配'
            })
          }
        }
        // 按时间排序
        data = data.sort(function(a,b){
          let time1 = new Date(a.time).getTime();
          let time2 = new Date(b.time).getTime();
          return time1 < time2 ? 1 : -1
        })
        return data
      },
      searchPost(){
        // 所有员工对应岗位 先判断是否是老板
        return function(val){
          if(this.$store.state.userInfo.bossId == val){
            return '老板'
          }else{
            if(this.postPerson){
              for(let i of this.postPerson){
                if(i.staffId == val){
                  for(let m of this.infolist){
                    if(m.id == i.postId){
                      return m.name
                    }
                  }
                } 
              }
            }
          }
        }
      }
  },
  watch: {
    '$route.params.id'(val){
      if(val){
        this.detailInfo();
      }
    }
  },
  methods: {
    detailInfo() {
      if(this.$route.params.id){
        getOrderServeDetails({
          orderServeId: Number(this.$route.params.id)
        }).then(res => {
          if (res.code == 1) {
            this.form = res.data;
            if(this.form.scheduleStartTime){
              this.form.scheduleStartTime = formatDate(this.form.scheduleStartTime,'yyyy-MM-dd ')+formatDate(this.form.scheduleStartTime,'HH:mm')+'-'+formatDate(this.form.scheduleEndTime,'HH:mm')
            }
          }
        });
        allStaff({
          status:'1'
        }).then(res=>{
          this.postPerson = res.data
        })
      }
    },
    closeTab() {
      // 关闭当前tab
      this.$store.commit("delete_tabs", this.$route.path);
      this.$router.push("/financeManageCenter/serviceList");
    },
    cancelAbnormal(curRowchoose){
        // 异常取消
        this.$confirm( '您确定取消预约单吗？', "异常取消", {
            distinguishCancelAndClose: true,
            confirmButtonText: '确定',
            cancelButtonText: "取消",
            type: "warning"
        })
        .then(() => {
            this.dialogTableVisible = true;
            this.dialogType = 5;
            this.curChooseRow = curRowchoose;
            this.curChooseRow.id = Number(this.$route.params.id);
        })
        .catch(action => {
            if (action === "cancel") {
                this.$message({
                    type: "info",
                    message: "已取消"
                });
            }
        });
    },
    closeDialog(val) {
      this.dialogTableVisible = val;
      this.detailInfo();
    },
  }
};
</script>
<style lang="less" scoped>
.servicetoDetails {
  width: 1200px;
  overflow: hidden;
  margin: 0 auto;
  padding: 80px 0 60px;
  position: relative;
  .el-row.tit {
    color: #444;
    margin-bottom: 30px;
  }
  .el-row {
    margin-bottom: 15px;
    .point {
      color: #f83b56;
      font-size: 17px;
      font-weight: bold;
    }
    .myTxt {
      padding-left: 105px;
      margin-top: -30px;
    }
  }
  .listLineH{
    margin: -25px 0 0 105px;
    word-wrap: break-word;
    word-break: break-all;
  }
  label {
    width: auto;
    text-align: right;
    display: inline-block;
    margin-right: 10px;
    span {
      min-width: 95px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      display: inline-block;
      padding: 0 15px;
      background: #eff1f5;
      border-radius: 15px;
      color: #444;
    }
  }
  .payTypes{
    padding-left: 105px;
    margin-top: -26px;
  }
  .seize {
    height: 20px;
  }
  .logDetails{
      padding:20px 0 50px 0;
      border-left: 2px solid #e4e7ed;
      .leftpoint{
          padding-left: 30px;
          margin-bottom: 10px;
          position: relative;
          &::before{
            content: '';
            width: 12px;
            height: 12px;
            border:2px solid #e4e7ed;
            border-radius: 50%;
            background:#fff;
            position:absolute; 
            left: -7px;
            top: 4px
          }
      }
  }
}
</style>
<style lang="less">
.servicetoDetails {
  .el-table td,
  .el-table th {
    padding: 0;
  }
  .btnOptionsLast {
    text-align: center;
    margin: 0;
    .el-button {
      width: 135px;
      height: 46px;
    }
  }
  .el-dialog__title{
    font-weight:bold
  }
  .tableGoods {
    &.el-row {
      margin-bottom: 0;
    }
    .myTitle {
      width: 100%;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .el-table__header {
    background: rgb(239, 241, 245);
  }
  .delete {
    color: #f83b56;
    border: 1px solid #f83b56;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/businessManagementCenter/servicetoDetail.vue